import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mpro-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  faTimes = faTimes

  @Input() button: string = "";
  @Input() dismiss: boolean = false;
  @Input() time: number = -1;
  @Input() title: string = "";
  @Input() text: string = "";

  @HostBinding("class") @Input() color: string
  @HostBinding("class.dark") @Input() dark: boolean = false
  buttonColor: string = "gray"
  buttonHue: string = "800"

  @HostBinding("style.--max-width") @Input() maxWidth: string = "none";
  @HostBinding("style.--time") timeString: string = "";

  @Output() btnClick = new EventEmitter()
  @Output() dismissEvent = new EventEmitter()

  ngOnInit(): void {
    if (this.time !== -1) {
      this.timeString = this.time + "s"
      setTimeout(() => {
        this.close()
      }, (this.time * 1000))
    }
    if (this.dark) {
      this.buttonColor = this.color
    }
  }

  onClick() {
    this.btnClick.emit()
  }

  close() {
    this.dismissEvent.emit()
  }

}